<mdb-navbar  SideClass="navbar navbar-expand-lg navbar-dark bg-dark">

    <!-- Navbar brand -->
    <mdb-navbar-brand><a class="navbar-brand"(click)="home()" >Home</a></mdb-navbar-brand>
  
    <!-- Collapsible content -->
    <links>
  
        <!-- Links -->
        <ul class=" navbar-dark navbar-nav mr-auto">
            <li class="nav-item">
                <a  class=" nav-link waves-dark" (click)="addnewbill()" mdbWavesEffect>Add New Bill</a>
            </li>
            <li class="nav-item">
                <a class="nav-link waves-dark"(click)="viewbill()" mdbWavesEffect>View Bill</a>
            </li>
            <li class="nav-item">
                <a class="nav-link waves-dark"(click)="editbill()" mdbWavesEffect>Edit Bill</a>
            </li>
            <li class="nav-item">
                <a class="nav-link waves-dark" (click)="deletebill()" mdbWavesEffect>Cancel Bill</a>
            </li>
        </ul>
            <!-- Dropdown -->
            <ul class="navbar-nav ml-auto nav-flex-icons">
            
                <li class="nav-item">
                  <a class="nav-link waves-dark" (click)="logout()" mdbWavesEffect>Login/Logout</a>
            
              </li>
              </ul>
  
       
        <!-- Links -->
  
  <!-- Search form -->
  
    </links>
    <!-- Collapsible content -->
  
  </mdb-navbar>

<router-outlet></router-outlet>